import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DropDown from '../../../../../src/components/DropDown';
import { useReportContext } from '../../components/reportContext';
import { useGetAllCourseListMutation, useGetClassesMutation } from '../../../../features/authentication/authApiSlice';
import { useUpdateCourseIdMutation, useUpdateClassIdMutation, useGetDropdownValuesMutation } from '../../../../features/authentication/persistApiSlice';
import { useGetMathSkillStudentsMutation } from '../../../../features/authentication/classesApiSlice';
import CustomToast from '../../../../components/Toast';
import SkeletonGrid from '../../../../components/SkeletonLoader/SkeletonGrid';
import { useNavigate } from 'react-router';

const MathSkillReportFilter = () => {
  const { selectedClassId, setSelectedClassId, selectedCourseId, setSelectedCourseId, selectedStudentId, setSelectedStudentId } = useReportContext();
  const [getAllCourses] = useGetAllCourseListMutation();
  const [getAllClasses] = useGetClassesMutation();
  const [getMathSkillStudents] = useGetMathSkillStudentsMutation();
  const [persistCourseId] = useUpdateCourseIdMutation();
  const [persistClassId] = useUpdateClassIdMutation();
  const [getDropdownPersistValues] = useGetDropdownValuesMutation();
  const [classes, setClasses] = useState([]);
  const [courses, setCourses] = useState([]);
  const [students, setStudents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const mathSkillCourses = [14,26,101];

  useEffect(() => {
    fetchDropDownData();
  }, []);

  useEffect(() => {
    if (selectedClassId > 0 && selectedCourseId > 0)
      getMathSkillStudentsAsync();
  }, [selectedClassId, selectedCourseId]);

  const fetchDropDownData = async () => {
    setIsLoading(true);
    var courses = await getAllCourses().unwrap();
    var skillCourses = courses.filter((item)=> mathSkillCourses.includes(item.id));
    setCourses(skillCourses);
    
    let classes = localStorage.getItem('classes');
    if (classes) {
      classes = JSON.parse(classes);
      setClasses([
        ...classes.map((item) => ({
          name: item.className,
          id: item.classID,
          coteacherName: item.coTeacherClass ? item.teacherName : '',
          coTeacherClass: item.coTeacherClass
        }))
      ]);
    } else {
      loadClasses();
    }
    var persistValues = await getDropdownPersistValues().unwrap();
    setSelectedCourseId(persistValues.courseId == -1 ? skillCourses[0]?.id : persistValues.courseId);
    setSelectedClassId(persistValues.classId == -1 ? classes[0]?.classID : persistValues.classId);
    setIsLoading(false);
  };

  async function loadClasses() {
    var classes = await getAllClasses().unwrap();
    localStorage.setItem('classes', JSON.stringify(classes));

    setClasses([
      ...classes.map((item) => ({
        name: item.className,
        id: item.classID,
        coteacherName: item.coTeacherClass ? item.teacherName : '',
        coTeacherClass: item.coTeacherClass
      }))
    ]);
  }

  const getMathSkillStudentsAsync = async () => {
    setIsLoading(true);
    setStudents([]);
    setSelectedStudentId(0);
    const options = {
      classId: selectedClassId,
      courseId: selectedCourseId
    };
    const response = await getMathSkillStudents(options);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Name, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    }
    else if (response.data && response.data.length > 0) {
      var updatedStudents = response.data.filter(item => item.viewReport).map(item => ({
        id: item.studentId,
        name: item.lName + ' ' + item.fName
      }));
      if(updatedStudents.length == 0)
        CustomToast('No students found in this selected criteria.', 'error');
      else{
        const obj = {
          id: 0,
          name: 'Select Student'
        };
        const studentsArray = [obj, ...updatedStudents];
        setStudents(studentsArray);
      }
    }
    else
      CustomToast('No students found in this selected criteria.', 'error');
    setIsLoading(false);
  };

  const handleClassChange = async (e) => {
    setSelectedClassId(parseInt(e.target.value));
    await persistClassId(parseInt(e.target.value));
  };

  const handleCourseChange = async (e) => {
    setSelectedCourseId(parseInt(e.target.value));
    await persistCourseId(parseInt(e.target.value));
  };

  return (
    <>
      <div className='white-card'>
        <div className='align-items-center d-flex justify-content-between mb-4'>
          <h1 className='mb-4'>Math Skill Report</h1>
          <div>
            <button
              onClick={() => window.history.back()}
              className="btn btn-castleWhite report-btn">
              Back
            </button>
          </div>
        </div>
        {isLoading ? (
          <SkeletonGrid
            rowCount={1}
            colCount={3}
            className={'mt-5 p-2'} />
        ) : (
          <>
            <Row>
              <Col>
                <DropDown
                  key='classSelect'
                  label="Class"
                  value={classes}
                  onChangeHandler={(e) => handleClassChange(e)}
                  selectedValue={selectedClassId}
                  dropDownName={'Class'}
                  description={true}
                />
              </Col>
              <Col>
                <DropDown
                  key='courseSelect'
                  label="Course"
                  value={courses}
                  onChangeHandler={(e) => handleCourseChange(e)}
                  selectedValue={selectedCourseId}
                  dropDownName={'Course'}
                />
              </Col>
              <Col>
                <DropDown
                  key='studentSelect'
                  label="Student"
                  value={students}
                  onChangeHandler={(e) => setSelectedStudentId(parseInt(e.target.value))}
                  selectedValue={selectedStudentId}
                  dropDownName={'Students'}
                />
              </Col>
            </Row>
            <div className='w-100 d-flex gap-3 mt-4 justify-content-end'>
              <button className={`w-10 btn btn-castleRed ${selectedStudentId == 0 && 'disabled'}`} onClick={() => navigate(`${selectedCourseId}/${selectedStudentId}/skillReport`)}>
               Create Report
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default MathSkillReportFilter;
